import { render, staticRenderFns } from "./deleteOrder.vue?vue&type=template&id=622314b0&scoped=true&"
import script from "./deleteOrder.vue?vue&type=script&lang=js&"
export * from "./deleteOrder.vue?vue&type=script&lang=js&"
import style0 from "./deleteOrder.vue?vue&type=style&index=0&id=622314b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622314b0",
  null
  
)

export default component.exports